import { Button, Select } from "antd";
import React, { useCallback, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import useGroupItemContext from "../../../hooks/useGroupItemContext";
import { ContainerSelectGroupItem, CustomSelect } from "./styles";

function SelectGroupItem({
  customSelect = false,
  placeholder = null,
  value,
  onDeselect,
  onChange,
  disabled = false,
  allowClear = true,
  showSearch = true,
}) {
  const { translation } = useSelector((state) => state.app);
  const {
    options,
    isLoadingOptions,
    fetchOptions,
    openDrawer,
    lastSaved,
    isDrawerVisible,
  } = useGroupItemContext();

  const awaitingCreate = useRef(false);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  useEffect(() => {
    if (awaitingCreate.current && lastSaved?.id) {
      onChange(lastSaved.id);
      awaitingCreate.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSaved]);

  // Declared after the lastSaved effect on purpose: when a save and the drawer
  // close land together, the auto-select must run before the flag is cleared.
  useEffect(() => {
    if (!isDrawerVisible) awaitingCreate.current = false;
  }, [isDrawerVisible]);

  const createNewGroupItem = useCallback(() => {
    awaitingCreate.current = true;
    openDrawer();
  }, [openDrawer]);

  const activeGroupItems = options.filter(
    (groupItem) => groupItem.status !== "Inactive",
  );

  const optionElements = activeGroupItems.map((groupItem) => (
    <Select.Option key={groupItem.id} value={groupItem.id}>
      {groupItem.name}
    </Select.Option>
  ));

  const hasMatchingOption = activeGroupItems.some(
    (groupItem) => groupItem.id === value,
  );

  const selectProps = {
    loading: isLoadingOptions,
    value: hasMatchingOption ? value : undefined,
    placeholder: placeholder
      ? placeholder
      : translation.defaultSelectPlaceholder,
    showSearch,
    optionFilterProp: "children",
    filterOption: (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    allowClear,
    disabled,
    onDeselect,
    onChange,
  };

  const SelectElement = customSelect ? (
    <CustomSelect {...selectProps}>{optionElements}</CustomSelect>
  ) : (
    <Select {...selectProps}>{optionElements}</Select>
  );

  return (
    <ContainerSelectGroupItem>
      {SelectElement}
      <Button
        shape="circle"
        icon="plus"
        disabled={disabled}
        onClick={createNewGroupItem}
      />
    </ContainerSelectGroupItem>
  );
}

export default SelectGroupItem;
